import { Database } from "lucide-react";

/** La riga che sostituisce le aree di caricamento dei file letti dal gestionale. */
export function DalGestionaleNota({ tipi }: { tipi: { slug: string; label: string }[] }) {
  if (tipi.length === 0) return null;
  return (
    <div
      className="md:col-span-2 rounded-lg border border-emerald-300/60 bg-emerald-50/60 dark:bg-emerald-950/20 px-3 py-2.5 text-sm flex items-start gap-2.5"
      data-testid="dal-gestionale"
    >
      <Database className="size-4 text-emerald-700 dark:text-emerald-300 shrink-0 mt-0.5" />
      <div>
        <p className="font-medium text-foreground">Dal gestionale, in automatico</p>
        <p className="text-muted-foreground text-xs mt-0.5">
          {tipi.map((t) => t.label).join(" · ")}: si leggono da Business Cube ogni 15 minuti,
          non serve più caricare il file.
        </p>
      </div>
    </div>
  );
}
